import { profileDeviceSchemaSignal, profileDeviceSchemaLoadedSignal, profileDeviceSchemaErrorSignal } from '../signals/profileDeviceSchemaSignals'

export const fetchProfileDeviceSchema = async (deviceName, manifest) => {
    profileDeviceSchemaLoadedSignal.value = false
    profileDeviceSchemaSignal.value = null
    const manifestDeviceEntry = manifest["device-profiles"].find(p => p.name == deviceName && p.version == 2)
    if (!manifestDeviceEntry) {
        throw new Error(`Unable to locate the device schema manifest entry for ${deviceName}.`)
    }
    // TODO: the manifest file assumes all schemas are in the /react/* folder. 
    // we'll have to adjust the manifest file but for now remove this path
    const filePath = manifestDeviceEntry.file.startsWith('/react') ? manifestDeviceEntry.file.slice(6) : manifestDeviceEntry.file
    return await fetch(filePath).then(
        async (response) => {
            return await response.json().then(
                (data) => {
                    profileDeviceSchemaSignal.value = data
                    profileDeviceSchemaLoadedSignal.value = true
                    return data
                }
            )
        }
    ).catch(
        (err) => {
            profileDeviceSchemaErrorSignal.value = err
            console.error(err)
            throw err
        }
    )
}